import React from "react";
import { useTranslation } from "react-i18next";
import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from "react-icons/md";
import EAButton from "../../../shared/Buttons/EAButton";

interface BasketSurveyNavProps {
  isLastItem: boolean;
  isSaving: boolean;
  onBackClick: () => void;
  onNextClick: () => void;
}

const BasketSurveyNav: React.FC<BasketSurveyNavProps> = ({
  isLastItem,
  isSaving,
  onBackClick,
  onNextClick,
}) => {
  const { t } = useTranslation();

  return (
    <div className="basket-survey-step__navigation">
      <EAButton
        title={t("poprzedni")}
        variant="outlined"
        startIcon={<MdOutlineKeyboardArrowLeft />}
        disabled={isSaving}
        onClick={onBackClick}
      />
      <EAButton
        title={isLastItem ? t("przejdz_dalej") : t("nastepny_krok")}
        endIcon={<MdOutlineKeyboardArrowRight />}
        disabled={isSaving}
        loading={isSaving && isLastItem}
        onClick={onNextClick}
      />
    </div>
  );
};

export default BasketSurveyNav;
